import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

type MenuUIState = {
  expandedItems: number[];
};

const initialState: MenuUIState = {
  expandedItems: [],
};

const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    toggleMenuItem: (state, action: PayloadAction<number>) => {
      const itemId = action.payload;
      const index = state.expandedItems.indexOf(itemId);

      if (index >= 0) {
        state.expandedItems.splice(index, 1);
      } else {
        state.expandedItems.push(itemId);
      }
    },

    expandMenuItem: (state, action: PayloadAction<number>) => {
      const itemId = action.payload;
      if (!state.expandedItems.includes(itemId)) {
        state.expandedItems.push(itemId);
      }
    },

    collapseMenuItem: (state, action: PayloadAction<number>) => {
      const itemId = action.payload;
      const index = state.expandedItems.indexOf(itemId);
      if (index >= 0) {
        state.expandedItems.splice(index, 1);
      }
    },

    collapseAllItems: (state) => {
      state.expandedItems = [];
    },
  },
});

export const { toggleMenuItem, expandMenuItem, collapseMenuItem, collapseAllItems } =
  menuSlice.actions;

export default menuSlice.reducer;

export const selectExpandedItems = (state: { menu: MenuUIState }) => state.menu.expandedItems;
